const feathers = require('feathers/client')
const socketio = require('feathers-socketio/client')
const hooks = require('feathers-hooks')
// const errors = require('feathers-errors')
const auth = require('feathers-authentication-client')
const io = require('socket.io-client/dist/socket.io')

// const socket = io('https://lifturi.dragos.club', {
const socket = io('https://dec18.verdedata.ro', {
// const socket = io('http://localhost:3033', {
  transports: ['websocket']
})

const feathersClient = feathers()
  .configure(socketio(socket, {timeout: 600000 * 60}))
  .configure(hooks())
  .configure(auth({ storage: localStorage }))

export default feathersClient



// WEBPACK FOOTER //
// ./src/feathers/index.js